import { render, staticRenderFns } from "./tryAssessmentHome.vue?vue&type=template&id=6098d44e&scoped=true&"
import script from "./tryAssessmentHome.vue?vue&type=script&lang=js&"
export * from "./tryAssessmentHome.vue?vue&type=script&lang=js&"
import style0 from "./tryAssessmentHome.vue?vue&type=style&index=0&id=6098d44e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6098d44e",
  null
  
)

export default component.exports